module.exports = __webpack_public_path__ + "img/icon-binoculars-light.7cea5247.svg";